import { Plugins } from '@leverege/plugin';
import { GlobalState, UserSettings } from '@leverege/ui-redux';
import LayoutModel from "../layout/LayoutModel.js";
import DataViewerModel from "../DataViewerModel.js";
/**
 * This converts the old ViewerModel to a new LayoutModel. The ViewerModel
 * used UsersSettings to save all the models. The LayoutModel will directly
 * embed them in the model, allowing for better copy support
 */
const KEYS = ['aux1', 'aux2', 'aux3', 'aux4', 'main1', 'main2'];
const MAP = {
  aggregations: 'molten.Aggregations',
  dashboard: 'molten.Dashboard',
  map: 'molten.Map',
  table: 'molten.Table',
  list: 'molten.List',
  responsiveTable: 'molten.TableList',
  'molten.GroupingsViewer': 'molten.Groupings',
  responsiveHistoryTable: 'molten.History',
  historyList: 'molten.HistoryList',
  historyTable: 'molten.HistoryTabel'
};
const cache = new Map();
export default {
  getConverted(mdl) {
    const cMdl = cache.get(mdl);
    return cMdl;
  },
  convert(mdl, opts) {
    if (mdl?.type === LayoutModel.TYPE) {
      return mdl;
    }
    const cMdl = cache.get(mdl);
    if (cMdl) {
      return cMdl;
    }
    const converters = Plugins.createFactory('ViewerModelConverter', {
      strategy: Plugins.LOOKUP,
      creationKey: 'converter'
    });
    if (opts.usedSettingsPath == null) {
      // eslint-disable-next-line no-param-reassign
      opts.usedSettingsPath = new Set();
    }
    const {
      settingsRoot,
      usedSettingsPath,
      getSettingsAt = defaultGetSettingsAt
    } = opts || {};

    // eslint-disable-next-line no-param-reassign
    mdl = mdl || {};
    const model = LayoutModel.create();
    KEYS.forEach(key => {
      const type = mdl[key];
      if (typeof type === 'string') {
        const settingsPath = `${settingsRoot}/${type}`;
        if (converters.get(type)) {
          model[key] = converters.create({
            type
          })(type, {
            settingsRoot,
            usedSettingsPath,
            type,
            settingsPath,
            converters,
            getSettingsAt
          });
        } else {
          // Default - get settings and make a data viewer object
          const settings = getSettingsAt(settingsPath);
          opts.usedSettingsPath.add(settingsPath);
          if (MAP[type] == null) {
            MAP[type] = type;
            // eslint-disable-next-line no-console
            console.log('No mapping supplied for ', type);
          }
          model[key] = DataViewerModel.create(MAP[type] || type, settings);
        }
      }
    });

    // console.log( 'convert', JSON.stringify( model, null, 2 ))
    cache.set(mdl, model);
    // console.log( 'converted', mdl, 'to', model )
    // console.log( 'Used paths', usedSettingsPath )
    return model;
  }
};
function defaultGetSettingsAt(path) {
  // UserSettings adds this back on
  const minusRoot = path.split('/').slice(2).join('/');
  return UserSettings.get(GlobalState.get(), minusRoot, {
    cacheOnly: true,
    returnPromise: false
  });
}